<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <!--Boxicons v3.0.8 https://boxicons.com | License  https://docs.boxicons.com/free-->
    <path
      d="M20 6h-4V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v17c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V8c0-1.1-.9-2-2-2m0 14h-9v-5H7v5H4V4h10v3c0 .55.45 1 1 1h5z"
    ></path>
    <path d="M16 10h2v2h-2zm0 4h2v2h-2zm-6-8H8v2H6v2h2v2h2v-2h2V8h-2z"></path>
  </svg>
</template>
